import { create } from 'zustand'
import apiHandler from 'components/Defaults/ApiHandler'
import axios from 'axios'

export const getCover = (id, callback, errorCallback) => {
  const config = {
    url: `/api/cover/${id}/medium`,
    responseType: 'arraybuffer'
  }
  apiHandler(
    "Getting cover",
    config,
    async cfg => {
      const response = await axios.request(cfg)
      const blob = new Blob([response.data], { type: 'image/jpeg' })
      const objectURL = URL.createObjectURL(blob)
      callback && callback(objectURL)
    },
    errorCallback
  )
}

export const useCoverStore = create((set, get) => ({
  // covers[id] = { data: string | null, loading: boolean, error: any }
  covers: {},

  fetchCover: id => {
    const existing = get().covers[id]
    // If we already have data or a loading in flight, bail out
    if (existing?.loading || existing?.data) return

    // mark this cover as loading
    set(state => ({
      covers: {
        ...state.covers,
        [id]: { data: null, loading: true, error: null }
      }
    }))

    // fetch the cover
    getCover(
      id,
      data => {
        set(state => ({
          covers: {
            ...state.covers,
            [id]: { data, loading: false, error: null }
          }
        }))
      },
      error => {
        set(state => ({
          covers: {
            ...state.covers,
            [id]: { data: null, loading: false, error }
          }
        }))
      }
    )
  }
}))
